let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fHLos")).then(() => parcelRequire('6Ajhr'));